import { styled } from "@mui/material";
import { FC } from "react";

import { availableStatusColors, STATUS_TYPE } from "../../types/status";

type SizeType = "normal" | "large";

export interface StatusIndicatorProps {
  /** Screen size */
  size?: SizeType;
  /** Color status, traffic-light approach, can also be a hex color in a string */
  status: STATUS_TYPE | string;
}

const isLarge = (size: SizeType) => size === "large";
const Status = styled("span")<{ size: SizeType }>(({ size }) => ({
  width: isLarge(size) ? 20 : 15,
  height: isLarge(size) ? 20 : 15,
  display: "inline-block",
}));

export const StatusIndicator: FC<StatusIndicatorProps> = ({
  status,
  size = "normal",
}) => {
  let background: string, border: string, borderRadius: string;

  if (isStatusType(status)) {
    background = availableStatusColors[status];
    border =
      status.toUpperCase() === STATUS_TYPE.COMPLETED
        ? "2px solid #003781"
        : "1px solid #DFEFF2";
    borderRadius =
      status.toUpperCase() === STATUS_TYPE.COMPLETED ? "20%" : "50%";
  } else {
    background = status;
    border = "1px solid #DFEFF2";
    borderRadius = "50%";
  }

  return (
    <Status
      data-testid="StatusIndicator"
      size={size}
      sx={{
        background,
        border,
        borderRadius,
        backgroundPosition: "center",
        width: isLarge(size) ? 20 : 15,
        height: isLarge(size) ? 20 : 15,
      }}
    />
  );
};

export function isStatusType(
  status: STATUS_TYPE | string
): status is STATUS_TYPE {
  return Object.values(STATUS_TYPE).some((s: string) => s === status);
}
